import { baseUrl } from "features/api";

export const bucketUploadsUrl = `${baseUrl}bucket-uploads/`;
export const chunkedUrl = `${baseUrl}chunks/chunk/`;
export const chunkedCompleteUrl = `${baseUrl}chunks/complete/`;
